import { render, staticRenderFns } from "./prodottoCarrello.vue?vue&type=template&id=73c4e726&"
import script from "./prodottoCarrello.vue.ts?vue&type=script&lang=ts&"
export * from "./prodottoCarrello.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports